import styled from 'styled-components'

import { media } from '../../../../../styles/breakpoints'

import { SCAN_HEALTH_SIDE_RAIL_TOP } from './ScanHealthLeftRail'
import { ScanHealthLegend } from './ScanHealthLegend'

export const ScanHealthRightRail = () => (
  <RailInner>
    <ScanHealthLegend />
  </RailInner>
)

const RailInner = styled.div`
  width: 220px;
`

export const DesktopRightRail = styled.aside`
  position: fixed;
  right: 24px;
  top: ${SCAN_HEALTH_SIDE_RAIL_TOP};
  width: 220px;
  z-index: 12;

  @media ${media.belowTablet} {
    display: none;
  }
`

export const MobileRightRail = styled.div`
  display: none;

  @media ${media.belowTablet} {
    display: block;
    width: 100%;
    margin: 0 0 16px;
  }
`
